import { useMemo } from 'react';
export const useWidthNode = (ref, refrash) => {
    return useMemo(() => {
        if (ref === null) {
            return 0;
        }
        const rect = ref && ref.getBoundingClientRect();
        const { width = 0 } = rect;
        return Math.round(width);
    }, [ref, refrash]);
};
